import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50077 2.44031C9.80988 2.16459 10.284 2.19166 10.5597 2.50077L12 4.1155L13.4403 2.50077C13.716 2.19166 14.1901 2.16459 14.4992 2.44031C14.8084 2.71603 14.8354 3.19013 14.5597 3.49924L13.674 4.49222H19.5C20.7426 4.49222 21.75 5.49958 21.75 6.74222V17.1955C21.75 18.4381 20.7426 19.4455 19.5 19.4455H18.75V21C18.75 21.4142 18.4142 21.75 18 21.75C17.5858 21.75 17.25 21.4142 17.25 21V19.4455H6.75V21.1176C6.75 21.5319 6.41421 21.8676 6 21.8676C5.58579 21.8676 5.25 21.5319 5.25 21.1176V19.4455H4.5C3.25736 19.4455 2.25 18.4381 2.25 17.1955V6.74222C2.25 5.49958 3.25736 4.49222 4.5 4.49222H10.326L9.44031 3.49924C9.16459 3.19013 9.19166 2.71603 9.50077 2.44031Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
